import { history } from '@umijs/max';
import { Button, Card, Result } from 'antd';
import React from 'react';

interface UnderConstructionProps {
  title?: string;
  subTitle?: string;
  expectedVersion?: string;
}

export const UnderConstruction: React.FC<UnderConstructionProps> = ({
  title = '功能正在建设中',
  subTitle = '该模块目前正在接入真实业务后台服务，敬请期待。',
  expectedVersion,
}) => {
  return (
    <div style={{ padding: '24px' }}>
      <Card
        bordered={false}
        style={{
          minHeight: 480,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Result
          status="info"
          title={title}
          subTitle={
            <div>
              <p>{subTitle}</p>
              {expectedVersion && (
                <p style={{ color: '#8c8c8c', fontSize: 13, marginTop: 4 }}>
                  计划版本：{expectedVersion}
                </p>
              )}
            </div>
          }
          extra={
            <Button
              type="primary"
              onClick={() => history.push('/workbench/overview')}
            >
              返回工作台
            </Button>
          }
        />
      </Card>
    </div>
  );
};

export default UnderConstruction;
